'use strict';

import cookieData from './cookie-data';

/**
 * @param $toggler
 */
function filterCookie ($toggler) {
	let data = $toggler.data('filter-cookie');
	if (data) {
		let add = $toggler.hasClass('is-active');
		if (add) {
			if	(!cookieData.receive(data.name)) {
				cookieData.add(data.name, data.value, {path: '/'});
			}
		} else {
			cookieData.add(data.name, 0, {expires: -1, path: '/'});
		}
	}
}

export default function toggle ($togglers) {
	$togglers.each((i, toggler) => {
		let $toggler = $(toggler);
		let ns = i;
		let presetList = window.projectConfig.plugin.toggle.preset;
		let currentPreset = $toggler.data('toggle');
		// let params = (typeof currentPreset === 'string' && currentPreset in presetList) ? presetList[currentPreset] : currentPreset;
		let params = null;

		if (typeof currentPreset === 'string') {
			if (currentPreset in presetList) {
				params = presetList[currentPreset];
			} else {
				console.warn(`Invalid preset [${currentPreset}] for $toggler\n`, $toggler);
				return;
			}
		} else {
			params = currentPreset;
		}

		let {
			context = $toggler.parent(),
			map = {},
			opening = [],
			closing = [],
			stops = [],
			focusTarget = null,
			clearInputs = null,
			toggleOnBlur = true,
			onlyOne = true
		} = params;
		let $body = $('body');
		let toggle = (map, action, cb) => {
			Object.keys(map).forEach((selector) => {
				let $node = null;

				if (/^html|body$/.test(selector)) {
					$node = $(selector);
				} else {
					$node = $(selector, context);
				}

				$node[action](map[selector]);
			});
			if (/^removeClass$/.test(action)) {
				$body.removeClass('waiting-for-tap');
			}
			if (cb) {
				cb();
			}
		};

		$toggler.data('ns', ns);

		opening.push($toggler.get(0));
		opening.forEach((selector) => {
			$(selector).on('click.toggle.open' + ns, (e) => {
				e.preventDefault();
				e.stopPropagation();

				if (onlyOne && !$toggler.data('is-open')) {
					$toggler.data('is-open', false);
					$(document).trigger('click.toggle.close');
				}

				toggle(map, 'toggleClass', () => {
					$toggler.data('is-open', true);
					filterCookie($toggler);

					if (focusTarget) {
						$(focusTarget).focus();
					}
					if (clearInputs && clearInputs.length) {
						clearInputs.forEach((selector) => {
							let $selector = $(selector, context);
							let $currentForm = $selector.closest('.js-form');
							let validator = $currentForm.data('validator');
							$selector.val('');
							if (validator !== 'undefined') {
								validator.resetElements($selector);
							}
						});
					}
					if ($toggler.hasClass('select-box--single')) {
						/**
						 * В данном случае, нужно чтобы выпадайка с опциями закрылась после выбора опции
						 * но с запозданием, чтоб прошел клик в выбранный элемент или ссылку или что там будет
						 */
						stops.forEach((selector) => {
							$(selector).on('click' + ns, (e) => {
								let tm = null;
								clearTimeout(tm);
								tm = setTimeout(() => {
									toggle(map, 'removeClass');
								}, 300);
							});
						});
					}
					/**
					 * Проверяем девайс (тач|не тач)(apple|не apple) и исходя из типа девайса вешать на body курсор поинтер или нет
					 * Нужно для того, чтобы клик по документу нормально отрабатывал на apple девайсах (iphone/ipad)
					 */
					if (window.Modernizr.touchevents && (window.Modernizr.iphone || window.Modernizr.ipad || window.Modernizr.ios)) {
						$body.addClass('waiting-for-tap');
					}
				});
			});
		});

		if (closing.length) {
			closing.forEach((selector) => {
				$(selector).on('click.toggle.close' + ns, () => {
					toggle(map, 'removeClass');
				});
			});
		}

		if (toggleOnBlur) {
			stops.forEach((selector) => {
				$(selector).on('click.toggle.stopBubble' + ns, (e) => {
					e.stopPropagation();
				});
			});
		}

		if (toggleOnBlur || onlyOne) {
			$(document).on('click.toggle.close', () => {
				$toggler.data('is-open', false);
				toggle(map, 'removeClass');
			});
		}
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/toggle.js